import api from './api';

export interface DemandaComRequisicao {
  id: string;
  identificadorTexto: string;
  dataAberturaDemandaString: string;
  demandante: string;
  diretoria: string;
  area: string;
  departamento: string;
  tipoDescricao: string;
  tipoServico: string;
  expectativaValorFinal: number;
  statusHistoricoDescricao: string;
}

export const getAllDemandasComRequisicaoComStatus = (status: number) =>
  api.get<DemandaComRequisicao[]>(`demandas/getAllDemandasComRequisicaoComStatus?status=${status}`);